exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content[data-v-4e06aa35] .ant-modal-header {\n  border-bottom: none;\n}\n.modal-content[data-v-4e06aa35] .ant-modal-body {\n  padding: 0 24px 10px;\n}\n.modal-content[data-v-4e06aa35] .ant-upload-picture-card-wrapper {\n  width: auto;\n}\n.modal-content .coverUrl-item[data-v-4e06aa35] .ant-upload {\n  width: 200px;\n}\n", ""]);

// exports
